export type ErrorHandler = (err: Error) => any;

let emitter: ErrorHandler | undefined;

// For unit testing purposes:
export const reset = () => {
  emitter = undefined;
};

export const init = (appErrorHandler?: ErrorHandler) => {
  // Use the app's error handler if available, then fall back to console.error:
  // tslint:disable-next-line: no-console
  emitter = appErrorHandler || console.error;
}

export const errorEmitter = (err: Error) => {
  if (!emitter) {
    // Make sure error emitter has been initiated before it executes the first time.
    init();
  }
  // Casting this, as TS thinks it would be possible for it to be undefined:
  (emitter as ErrorHandler)(err);
};
